import React from "react";
import { Grid, Header } from "semantic-ui-react";

const CampaniaListEmpty = () => {
  return (
    <Grid centered columns={1}>
      <Grid.Row>
        <Header as="h4" color="grey">
          <Header.Content>
            <br />
            En estos momentos no contamos con una campa&ntilde;a, pero te
            invitamos a visitar nuestra{" "}
            <a
              href="https://prymera.pe"
              target="_blank"
              rel="noopener noreferrer"
            >
              web
            </a>{" "}
            para ver nuestros productos
          </Header.Content>
        </Header>
      </Grid.Row>
    </Grid>
  );
};

export default CampaniaListEmpty;
